export const LOGIN_VERIFICATION_METHOD_HEADING =
  "login-verification-methods-heading";
export const LOGIN_VERIFICATION_METHOD_TEXT = "login-verification-methods-text";
export const OPTIONAL_LABEL = "optional-label";
export const PHONE_CHECK_ICON_ID = "phone-check-icon";
export const PHONE_LABEL = "phone-number-label";
export const PHONE_NUMBER = "phone-number";
export const PHONE_HELPER_TEXT = "phone-helper-text";
export const EDIT_LABEL = "review-your-information-edit";
export const REMOVE_LABEL = "remove-label";
export const ADD_LABEL = "add-label";
export const EMAIL_CHECK_ICON_ID = "email-check-icon";
export const EMAIL_LABEL = "email-address-label";
export const EMAIL_ADDRESS = "email-address";
export const GO_TO_DASHBOARD_BUTTON_ID = "go-to-dashboard-button";
export const GO_TO_DASHBOARD = "go-to-dashboard-button-label";
export const CHANGE_PREFERRED_VERIFICATION =
  "change-preferred-verification-modal-title";
export const CHANGE_PREFERRED_VERIFICATION_BUTTON_ID =
  "change-preferred-verification-method-button";
export const VERIFICATION_METHODS_CHECKBOX_LABEL =
  "login-verification-methods-checkbox-label";
export const VERIFICATION_METHODS_CHECKBOX_ID =
  "dont-show-verification-method-page";
export const VERIFICATION_METHODS_CHECKBOX_TEXT_ID =
  "dont-show-verification-method-page-text";
export const PHONE_ICON_ID = "phone-icon";
export const EMAIL_ICON_ID = "email-icon";
export const PHONE_NOT_REG_TEXT = "no-phone-text";
export const EMAIL_NOT_REG_TEXT = "no-email-text";
export const PHONE = "phone";
export const EMAIL = "email";
export const PHONE_NO = "phoneNo";
export const TOOLTIP_TEXT = "login-verification-methods-tooltip-text";
export const BUTTON_LABEL = "button";
export const CHANGE_TOAST = "change-toast";
export const REMOVE_TOAST = "remove-toast";
export const ADD_TOAST = "add-toast";
export const EDIT_TOAST = "edit-toast";
export const CHANGE_DESCRIPTION = "VERIFICATION_METHOD_UPDATED_SUCCESSFULLY";
export const REMOVE_DESCRIPTION = "VERIFICATION_METHOD_REMOVED_SUCCESSFULLY";
export const ARIA_LABEL = "aria-label";
export const TOP = "top";
export const PREFERRED_CONTACT_TOOLTIP_ID = "preferred-contact";

export const checkBoxLabel = {
  inputProps: { [ARIA_LABEL]: VERIFICATION_METHODS_CHECKBOX_ID },
};

export const phoneEmailConstants = (isPhone) => {
  if (isPhone) {
    return {
      circleIconId: PHONE_CHECK_ICON_ID,
      phoneEmailId: PHONE_NUMBER,
      phoneEmailLabel: PHONE_LABEL,
      verificationMethod: PHONE,
      emailOrPhoneNotRegistered: PHONE_NOT_REG_TEXT,
    };
  }
  return {
    circleIconId: EMAIL_CHECK_ICON_ID,
    phoneEmailId: EMAIL_ADDRESS,
    phoneEmailLabel: EMAIL_LABEL,
    verificationMethod: EMAIL,
    emailOrPhoneNotRegistered: EMAIL_NOT_REG_TEXT,
  };
};
